import React, { useState, useEffect } from 'react';
import {object, func, bool, string} from 'prop-types';

import {CloneObject, GetMeses} from '../../../utils/helpers';
import {getDateNow} from '../../../utils/convert';
import {isValidNumber} from '../../../utils/validator';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import {useLista} from '../../hooks/useLista';
import InputLista from '../../common/InputLista';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import InputNumber from '../../common/InputNumber';
import InputEjercicio from '../../common/InputEjercicio';
import {TIPS} from "../../../consts/tips";
import {Accordion, FormError, FormLabel, Modal, Select} from '../../common';

const ValuacionModal = (props) => {

    const entityInit = {
        id: 0,
        idInmueble: 0,
        idTipoValuacion: 0,
        ejercicio: "",
        mes: 0,
        valor: 0,
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            idTipoValuacion: props.data.entity.idTipoValuacion,
            ejercicio: props.data.entity.ejercicio,
            mes: props.data.entity.mes,
            valor: props.data.entity.valor
        });
    }
    useEffect(mount, [props.data.entity]);

    const [, getRowLista] = useLista({
        listas: ['TipoValuacion'],
        onLoaded: (listas, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoValuacion',
            timeout: 0
        }
    });

    const [formValues, formHandle, , formSet] = useForm({
        idTipoValuacion: 0,
        ejercicio: "",
        mes: 1,
        valor: 0
    });

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idTipoValuacion = parseInt(formValues.idTipoValuacion);
        row.ejercicio = formValues.ejercicio;
        row.mes = parseInt(formValues.mes);
        row.valor = formValues.valor;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoValuacion <= 0) errors.idTipoValuacion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.ejercicio.toString().length === 0) errors.ejercicio = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (formValues.mes <= 0) errors.mes = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (!isValidNumber(formValues.valor, true)) errors.valor = 'Ingresá un número mayor a cero';

        return errors;
    }

    function getFormatErrors() {

        const errors = {};
        if (props.disabled) return errors;

        const ejercicio = formValues.ejercicio.toString();
        if (ejercicio.length > 0) {
            if (!isValidNumber(formValues.ejercicio, true)) errors.ejercicio = 'Debe ser mayor a cero';
            else if (ejercicio.length !== 4) errors.ejercicio = 'Ingresá los 4 dígitos';
            else if (formValues.ejercicio > getDateNow().getFullYear()) errors.ejercicio = 'No puede superar el año actual';
        }

        return errors;
    }

    const getDescTipoValuacion = (id) => {
        const row = getRowLista('TipoValuacion', id);
        return (row) ? row.nombre : '';
    }

    return (
        <>

            <Modal
                size="lg"
                title={`Valuación: ${(state.entity.id > 0) ? getDescTipoValuacion(state.entity.idTipoValuacion) : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.VALUACION_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Valuación" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-4">
                                                <FormLabel htmlFor="idTipoValuacion" required>Tipo</FormLabel>
                                                <InputLista
                                                    name="idTipoValuacion"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoValuacion') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoValuacion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="TipoValuacion"
                                                />
                                                <FormError message={errorOf('idTipoValuacion')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-2">
                                                <FormLabel htmlFor="ejercicio" required>Ejercicio</FormLabel>
                                                <InputEjercicio
                                                    name="ejercicio"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('ejercicio') ? 'is-invalid' : ''}`}
                                                    value={formValues.ejercicio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('ejercicio')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <FormLabel htmlFor="mes" required>Mes</FormLabel>
                                                <Select
                                                    name="mes"
                                                    className={`form-control ${errorOf('mes') ? 'is-invalid' : ''}`}
                                                    value={formValues.mes}
                                                    options={GetMeses().map(item => ({value: item.key, label: item.value}))}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('mes')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <FormLabel htmlFor="valor" required>Valor</FormLabel>
                                                <InputNumber
                                                    name="valor"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('valor') ? 'is-invalid' : ''}`}
                                                    value={formValues.valor}
                                                    precision={2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('valor')} />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de valuación"
                                            processKey={props.processKey}
                                            entidad="Valuacion"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

ValuacionModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

ValuacionModal.defaultProps = {
    disabled: false
};

export default ValuacionModal;